!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("react-parallax", ["react"], t) : "object" == typeof exports ? exports["react-parallax"] = t(require("react")) : e["react-parallax"] = t(e.react);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    var t = {};

    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        __webpack_require__.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 3);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    function _typeof(e) {
      return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function _classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" != typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _inherits(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && _setPrototypeOf(e, t);
    }

    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = r(n(0)),
        i = function (e) {
      function Parallax() {
        return _classCallCheck(this, Parallax), _possibleConstructorReturn(this, _getPrototypeOf(Parallax).apply(this, arguments));
      }

      return _inherits(Parallax, e), Parallax;
    }(o.default.Component);

    t.Parallax = i;

    var a = function (e) {
      function Background() {
        return _classCallCheck(this, Background), _possibleConstructorReturn(this, _getPrototypeOf(Background).apply(this, arguments));
      }

      return _inherits(Background, e), Background;
    }(o.default.Component);

    t.Background = a;
  }, function (e, t, n) {
    "use strict";

    function getWindowHeight(e) {
      if (!e) return 0;
      var t = window,
          n = document,
          r = n.documentElement,
          o = n.getElementsByTagName("body")[0];
      return t.innerHeight || r.clientHeight || o.clientHeight;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getWindowHeight = getWindowHeight, t.isScrolledIntoView = function isScrolledIntoView(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = arguments.length > 2 ? arguments[2] : void 0;
      if (!n) return !1;
      var r = e.getBoundingClientRect().top - t,
          o = e.getBoundingClientRect().bottom + t;
      return r <= getWindowHeight(n) && o >= 0;
    }, t.getNodeHeight = function getNodeHeight(e, t) {
      return e ? t && "clientHeight" in t ? t.clientHeight : getWindowHeight(e) : 0;
    }, t.canUseDOM = function canUseDOM() {
      return !("undefined" == typeof window || !window.document || !window.document.createElement);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(4));
    t.Parallax = o.default;
    var i = r(n(7));
    t.Background = i.default;
  }, function (e, t, n) {
    "use strict";

    function _typeof(e) {
      return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" != typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = r(n(0)),
        i = n(1),
        a = n(5),
        s = n(2),
        u = r(n(6)),
        l = {
      position: "absolute",
      left: "50%",
      WebkitTransform: "translate3d(-50%, 0, 0)",
      transform: "translate3d(-50%, 0, 0)",
      WebkitTransformStyle: "preserve-3d",
      WebkitBackfaceVisibility: "hidden",
      MozBackfaceVisibility: "hidden",
      MsBackfaceVisibility: "hidden"
    },
        c = function (e) {
      function Parallax(e) {
        var t;
        return function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Parallax), (t = _possibleConstructorReturn(this, _getPrototypeOf(Parallax).call(this, e))).onWindowResize = function () {
          t.parentHeight = s.getNodeHeight(t.canUseDOM, t.parent), t.updatePosition();
        }, t.onWindowLoad = function () {
          t.updatePosition();
        }, t.onScroll = function () {
          if (t.canUseDOM) {
            var e = Date.now();
            e - t.timestamp >= 10 && s.isScrolledIntoView(t.node, 100, t.canUseDOM) && (window.requestAnimationFrame(t.updatePosition), t.timestamp = e);
          }
        }, t.onContentMount = function (e) {
          t.content = e;
        }, t.updatePosition = function () {
          if (t.content) {
            var e = !1;
            t.contentHeight = t.content.getBoundingClientRect().height, t.contentWidth = t.node.getBoundingClientRect().width, t.img && t.img.naturalWidth / t.img.naturalHeight < t.contentWidth / t.getImageHeight() && (e = !0);
            var n = a.getRelativePosition(t.node, t.canUseDOM);
            t.img && t.setImagePosition(n, e), t.bg && t.state.splitChildren.bgChildren.length > 0 && t.setBackgroundPosition(n);
          }
        }, t.state = {
          bgImage: e.bgImage,
          bgImageSrcSet: e.bgImageSrcSet,
          bgImageSizes: e.bgImageSizes,
          imgStyle: l,
          bgStyle: Object.assign(Object.assign({}, l), e.bgStyle),
          percentage: 0,
          splitChildren: a.getSplitChildren(e)
        }, t.canUseDOM = s.canUseDOM(), t.node = null, t.content = null, t.bgImageLoaded = !1, t.bgImageRef = void 0, t.parent = e.parent, t.parentHeight = s.getNodeHeight(t.canUseDOM, t.parent), t.timestamp = Date.now(), t.isDynamicBlur = a.getHasDynamicBlur(e.blur), t;
      }

      return function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && _setPrototypeOf(e, t);
      }(Parallax, e), function _createClass(e, t, n) {
        return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
      }(Parallax, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var e = this.props.parent,
              t = this.state,
              n = t.bgImage,
              r = t.bgImageSrcSet,
              o = t.bgImageSizes;
          this.parent = e || document, this.addListeners(), n ? this.loadImage(n, r, o) : this.updatePosition();
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          var t = this.props,
              n = t.parent,
              r = t.bgImage,
              o = t.bgImageSrcSet,
              i = t.bgImageSizes,
              a = this.state.bgImage;
          e.parent !== n && (this.removeListeners(this.parent), this.parent = n, n && this.addListeners()), this.parentHeight = s.getNodeHeight(this.canUseDOM, this.parent), a !== r && this.loadImage(r, o, i);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.removeListeners(this.parent), this.releaseImage();
        }
      }, {
        key: "setBackgroundPosition",
        value: function setBackgroundPosition(e) {
          var t = this.props,
              n = t.disabled,
              r = t.strength;

          if (!0 !== n) {
            var o = this.state.bgStyle,
                i = "translate3d(-50%, ".concat((r < 0 ? r : 0) - r * e, "px, 0)");
            this.setState({
              bgStyle: Object.assign(Object.assign({}, o), {
                WebkitTransform: i,
                transform: i
              }),
              percentage: e
            });
          }
        }
      }, {
        key: "setImagePosition",
        value: function setImagePosition(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = this.props,
              r = n.disabled,
              o = n.strength,
              i = n.blur,
              s = t ? "auto" : "".concat(this.getImageHeight(), "px"),
              u = t ? "".concat(this.contentWidth, "px") : "auto";

          if (!0 !== r) {
            var l = this.state.imgStyle,
                c = o < 0,
                f = (c ? o : 0) - o * e,
                p = "translate3d(-50%, ".concat(f, "px, 0)"),
                g = "none";
            i && (g = "blur(".concat(a.getBlurValue(this.isDynamicBlur, i, e), "px)")), this.setState({
              imgStyle: Object.assign(Object.assign({}, l), {
                height: s,
                width: u,
                WebkitTransform: p,
                transform: p,
                WebkitFilter: g,
                filter: g
              }),
              percentage: e
            });
          }
        }
      }, {
        key: "getImageHeight",
        value: function getImageHeight() {
          var e = this.props.strength,
              t = (e < 0 ? 2.5 : 1) * Math.abs(e);
          return Math.floor(this.contentHeight + t);
        }
      }, {
        key: "loadImage",
        value: function loadImage(e, t, n) {
          var r = this;
          this.releaseImage(), this.bgImageRef = new Image(), this.bgImageRef.onload = function () {
            r.setState({
              bgImage: e,
              bgImageSrcSet: t,
              bgImageSizes: n
            }, function () {
              return r.updatePosition();
            });
          }, this.bgImageRef.onerror = this.bgImageRef.onload, this.bgImageRef.src = e, this.bgImageRef.srcset = t || "", this.bgImageRef.sizes = n || "";
        }
      }, {
        key: "releaseImage",
        value: function releaseImage() {
          this.bgImageRef && (this.bgImageRef.onload = null, this.bgImageRef.onerror = null, delete this.bgImageRef);
        }
      }, {
        key: "addListeners",
        value: function addListeners() {
          this.canUseDOM && this.parent && (this.parent.addEventListener("scroll", this.onScroll, !1), window.addEventListener("resize", this.onWindowResize, !1), window.addEventListener("load", this.onWindowLoad, !1));
        }
      }, {
        key: "removeListeners",
        value: function removeListeners(e) {
          this.canUseDOM && (e && e.removeEventListener("scroll", this.onScroll, !1), window.removeEventListener("resize", this.onWindowResize, !1), window.removeEventListener("load", this.onWindowLoad, !1));
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props,
              n = t.className,
              r = t.style,
              i = t.bgClassName,
              a = t.contentClassName,
              s = t.bgImageAlt,
              l = t.renderLayer,
              c = t.bgImageStyle,
              f = this.state,
              p = f.bgImage,
              g = f.bgImageSrcSet,
              d = f.bgImageSizes,
              _ = f.percentage,
              y = f.imgStyle,
              b = f.bgStyle,
              h = f.splitChildren;
          return o.default.createElement("div", {
            className: "react-parallax ".concat(n),
            style: Object.assign({
              position: "relative",
              overflow: "hidden"
            }, r),
            ref: function ref(t) {
              e.node = t;
            }
          }, p ? o.default.createElement("img", {
            className: i,
            src: p,
            srcSet: g,
            sizes: d,
            ref: function ref(t) {
              e.img = t;
            },
            alt: s,
            style: Object.assign(Object.assign({}, y), c)
          }) : null, l ? l(Math.min(-(_ - 1), 1)) : null, h.bgChildren.length > 0 ? o.default.createElement("div", {
            className: "react-parallax-background-children",
            ref: function ref(t) {
              e.bg = t;
            },
            style: b
          }, h.bgChildren) : null, o.default.createElement(u.default, {
            onMount: this.onContentMount,
            className: a
          }, h.children));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(e) {
          return {
            splitChildren: a.getSplitChildren(e)
          };
        }
      }]), Parallax;
    }(i.Parallax);

    c.defaultProps = {
      bgClassName: "react-parallax-bgimage",
      bgImageAlt: "",
      className: "",
      contentClassName: "",
      disabled: !1,
      strength: 100
    }, t.default = c;
  }, function (e, t, n) {
    "use strict";

    function _typeof(e) {
      return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(0),
        o = n(2);

    function getPercentage(e, t, n) {
      return (n - e) / (t - e) || 0;
    }

    t.getPercentage = getPercentage, t.getRelativePosition = function getRelativePosition(e, t) {
      if (!t) return 0;
      var n = e.getBoundingClientRect(),
          r = n.top,
          i = n.height,
          a = o.getNodeHeight(t),
          s = i > a ? i : a;
      return getPercentage(-i, s, Math.round(r > s ? s : r));
    }, t.getSplitChildren = function getSplitChildren(e) {
      var t = [],
          n = r.Children.toArray(e.children);
      return n.forEach(function (e, r) {
        var o = e;
        o.type && o.type.isParallaxBackground && (t = t.concat(n.splice(r, 1)));
      }), {
        bgChildren: t,
        children: n
      };
    }, t.getHasDynamicBlur = function (e) {
      return "object" === _typeof(e) && void 0 !== e.min && void 0 !== e.max;
    }, t.getBlurValue = function (e, t, n) {
      return e ? t.min + (1 - n) * t.max : t;
    }, t.setBlur = function setBlur(e, t) {
      e.style.webkitFilter = "blur(".concat(t, "px)"), e.style.filter = "blur(".concat(t, "px)");
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(0));

    t.default = function ParallaxChildren(e) {
      var t = e.children,
          n = e.onMount,
          r = e.className;
      return o.default.createElement("div", {
        ref: function ref(e) {
          return n(e);
        },
        className: r || "react-parallax-content",
        style: {
          position: "relative"
        }
      }, t);
    };
  }, function (e, t, n) {
    "use strict";

    function _typeof(e) {
      return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function _classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" != typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = r(n(0)),
        i = function (e) {
      function Background() {
        return _classCallCheck(this, Background), _possibleConstructorReturn(this, _getPrototypeOf(Background).apply(this, arguments));
      }

      return function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && _setPrototypeOf(e, t);
      }(Background, e), function _createClass(e, t, n) {
        return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
      }(Background, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.className,
              n = e.children;
          return o.default.createElement("div", {
            className: "react-parallax-background ".concat(t)
          }, n);
        }
      }]), Background;
    }(n(1).Background);

    i.defaultProps = {
      className: ""
    }, i.isParallaxBackground = !0, t.default = i;
  }]);
});